import React from 'react';
import styles from '../styles/authErrorDisplay.module.css';

interface AuthErrorDisplayProps {
  error: string;
  onLogin: () => void;
  onRefresh?: () => void;
}

/**
 * Reusable component for displaying authentication errors with clear action buttons
 * Provides consistent, user-friendly error messaging across the app
 */
export const AuthErrorDisplay: React.FC<AuthErrorDisplayProps> = ({ 
  error, 
  onLogin, 
  onRefresh 
}) => {
  return (
    <div className={styles.authErrorContainer}>
      <div className={styles.authErrorIcon}>🔒</div>
      <h3 className={styles.authErrorTitle}>Session Expired</h3>
      <p className={styles.authErrorMessage}>{error}</p>
      <div className={styles.authErrorActions}>
        <button 
          onClick={onLogin} 
          className={styles.authErrorButtonPrimary}
        >
          Log In Again
        </button>
        {onRefresh && (
          <button 
            onClick={onRefresh} 
            className={styles.authErrorButtonSecondary}
          >
            Refresh Page
          </button>
        )}
      </div>
      <p className={styles.authErrorHelp}>
        After logging in, your work will be saved automatically.
      </p>
    </div>
  );
};

